var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/trendingplaylists", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.createPlaylist.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.playlistTitle,
                          expression: "rules.playlistTitle"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Title",
                        placeholder: "Enter Title",
                        "data-vv-name": "Title",
                        "cus-name": "Title",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.playlist.playlistTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.playlist, "playlistTitle", $$v)
                        },
                        expression: "playlist.playlistTitle"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.playlistDescription,
                          expression: "rules.playlistDescription"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Description",
                        placeholder: "Enter Description",
                        "data-vv-name": "Description",
                        "cus-name": "Description",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.playlist.playlistDescription,
                        callback: function($$v) {
                          _vm.$set(_vm.playlist, "playlistDescription", $$v)
                        },
                        expression: "playlist.playlistDescription"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.csvVideoCodes,
                          expression: "rules.csvVideoCodes"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Video Codes",
                        placeholder: "Enter Video Codes (comma separated)",
                        "data-vv-name": "Video Codes",
                        "cus-name": "Video Codes",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.playlist.csvVideoCodes,
                        callback: function($$v) {
                          _vm.$set(_vm.playlist, "csvVideoCodes", $$v)
                        },
                        expression: "playlist.csvVideoCodes"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.status.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.active,
                              expression: "rules.active"
                            }
                          ],
                          attrs: {
                            label: "playlist",
                            "data-vv-name": "active",
                            "cus-name": "active",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields,
                            list: _vm.status,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.playlist.active,
                            callback: function($$v) {
                              _vm.$set(_vm.playlist, "active", $$v)
                            },
                            expression: "playlist.active"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-fill btn-block",
                  attrs: { type: "submit", disabled: _vm.errors.any() }
                },
                [_vm._v("\n              Create Playlist\n            ")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22539052", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22539052","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/TrendingPlaylists/CreateTrendingPlaylist.vue
// module id = a8ib
// module chunks = 0